<template>
  <div>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
      <b-row>
        <b-col cols="" class="">
          <b-row>
            <b-col cols="">

              <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                <div>
                <h2 class="text-left mb-0">{{ $t('fileDropPage.title') }} </h2>
                <span class="mt-2">{{ $t('fileDropPage.subtitle') }}</span>
                </div>
                <div class="justify-content-between justify-content-sm-center flex-wrap">
                  <b-button @click="addDocument"
                    v-if="allowCreateDocDrivers || allowCreateDocEquipment || allowCreateDocCompany"
                    class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                    variant="primary">
                    <b-icon icon="plus" aria-hidden="true"></b-icon>
                    <p class="mb-0 ml-2 text-white">{{ $t('fileDropPage.addDocument') }}</p>
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="data-table team-data-table table-custom-border rounded-top">
                <div class="bg-white pt-3 pt-sm-4 rounded" v-if="!isTableMounted">
                  <div class="table_row team_table_row">
                    <div class="px-3 px-sm-4 pb-4" style="height: calc(100vh - 180px); overflow: hidden;">
                      <b-skeleton-table :rows="17" :columns="7"
                        :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                    </div>
                  </div>
                </div>
                <div class="bg-white pt-3 pt-sm-4 rounded" v-else>
                  <div class="table_row team_table_row">
                    <div class="equipment-border filter-box">
                      <div class="d-flex mb-4 px-3 px-sm-4">
                        <b-form-group class="text-left label font-weight-normal search-field mb-0">
                          <b-input-group class="username-input-field">
                            <b-form-input type="text" :placeholder="$t('fileDropPage.search')" v-model="filterFields.search_field"
                              class="unit f-12" @keyup.enter="getAllDocs()"></b-form-input>
                            <b-input-group-append>
                              <b-button variant="primary" @click="getAllDocs()">
                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                    stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </svg>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                        <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                          <div class="position-relative">
                            <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                              {{ activeFiltersCount }}
                            </div>
                            <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                              <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                  data-id="element-964">
                                  <line x1="21" x2="14" y1="4" y2="4"></line>
                                  <line x1="10" x2="3" y1="4" y2="4"></line>
                                  <line x1="21" x2="12" y1="12" y2="12"></line>
                                  <line x1="8" x2="3" y1="12" y2="12"></line>
                                  <line x1="21" x2="16" y1="20" y2="20"></line>
                                  <line x1="12" x2="3" y1="20" y2="20"></line>
                                  <line x1="14" x2="14" y1="2" y2="6"></line>
                                  <line x1="8" x2="8" y1="10" y2="14"></line>
                                  <line x1="16" x2="16" y1="18" y2="22"></line>
                                </svg>
                                <p class="mb-0 ml-2">{{ $t('fileDropPage.filters') }}</p>
                              </div>
                            </button>
                          </div>
                          <div class="table-columns-section ml-2 mt-0" @click="showColumns = true">
                            <button class="btn btn-table-columns-section">
                              <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round" class="lucide lucide-columns2 w-4 h-4" data-id="element-961">
                                  <rect width="18" height="18" x="3" y="3" rx="2"></rect>
                                  <path d="M12 3v18"></path>
                                </svg>
                                <p class="mb-0 ml-2">{{ $t('fileDropPage.columns') }}</p>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <b-table ref="tableRef" class="mt-2" responsive :fields="visibleFields" :items="items" hover
                      :sticky-header="'calc(100vh - 290px)'" :current-page="currentPage" :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy" selectable
                      select-mode="multi" no-select-on-click @row-selected="onRowSelected" :show-empty="emptyTable">
                      <template #head(selected)="">
                        <b-form-checkbox class="pl-0 w-fit-content" @change="selectRows($event)"
                          v-model="allRowsSelected">
                        </b-form-checkbox>
                      </template>
                      <template #cell(name)="data">
                        <div class="d-flex align-items-center">
                          <a>{{ data.value }}</a>
                        </div>
                      </template>
                      <template #cell(source)="data">
                        <svg v-if="data.value === 'BOT'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.07751 18.9975V15.5368H6.53822" stroke="#2D69F6" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M18.8442 8.34855C19.7053 12.9277 16.9031 17.4673 12.328 18.6933C8.82635 19.6315 5.25353 18.3694 3.07751 15.7545"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1.15502 11.6536C0.293936 7.07442 3.09617 2.53472 7.67127 1.30883C11.1727 0.370634 14.7452 1.63251 16.9213 4.24705"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M16.9219 1V4.46071H13.4612" stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M5.93818 10.4693C5.4485 10.3842 5.4485 9.6812 5.93818 9.59601C7.71219 9.28739 9.12316 7.93616 9.50822 6.17717L9.53773 6.04233C9.64368 5.55838 10.3328 5.55536 10.4429 6.03837L10.4788 6.1955C10.8781 7.94621 12.2894 9.28601 14.0585 9.59378C14.5506 9.67942 14.5506 10.3859 14.0585 10.4716C12.2894 10.7793 10.8781 12.1192 10.4788 13.8698L10.4429 14.027C10.3328 14.51 9.64368 14.507 9.53773 14.023L9.50822 13.8882C9.12316 12.1292 7.71219 10.778 5.93818 10.4693Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <svg v-else-if="data.value === 'Driver'" width="20" height="20" viewBox="0 0 20 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                            :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10.0004 11.3825C11.9122 11.3825 13.462 9.83266 13.462 7.92091C13.462 6.00916 11.9122 4.45937 10.0004 4.45937C8.08867 4.45937 6.53888 6.00916 6.53888 7.92091C6.53888 9.83266 8.08867 11.3825 10.0004 11.3825Z"
                            :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M4.08673 16.7876C4.7046 15.7734 5.57299 14.9352 6.60841 14.3536C7.64382 13.7719 8.81144 13.4664 9.99904 13.4664C11.1866 13.4664 12.3543 13.7719 13.3897 14.3536C14.4251 14.9352 15.2934 15.7734 15.9114 16.7876"
                            :stroke="data.item.document_status === 'approved' ? '#2CCE89' : data.item.document_status === 'in_review' ? '#FFC800' : '#FF0000'"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <div v-else>{{ data.value }}</div>

                      </template>
                      <template #cell(type)="data">
                        {{ data.value ? data.value : '-' }}
                      </template>
                      <template #cell(selected)="data">
                        <b-form-checkbox class="pl-0 w-fit-content" @change="checked(data.index, data.rowSelected)"
                          v-model="data.rowSelected">
                        </b-form-checkbox>
                      </template>
                      <template #cell(description)="data">
                        <v-app v-if="data.value && data.value !== 'null'">
                          <v-tooltip top>
                            <template #activator="{ on, attrs }">
                              <span class="w-fit-content item-description text-left" v-on="on" v-bind="attrs">{{
                                data.value
                              }}</span>
                            </template>{{ data.value }}
                          </v-tooltip>
                        </v-app>
                        <p v-else>-</p>
                      </template>

                      <template #cell(public)="data">
                        <b-form-checkbox :disabled="!allowUpdateDocEquipment" v-if="data.item.type === 'Trailer' ||
                          data.item.type === 'Vehicle' || data.item.type === 'Company' || data.item.type === 'Tag Doc'
                          " v-model="data.value" name="check-button" switch @change="
    updateDocumentOnToggle(
      data.item,
      'public',
      data.value
    )
    " size="lg" class="ml-2" />
                      </template>
                      <template #cell(file_drop)="data">
                        <b-form-checkbox :disabled="!checkUpdateStatus(data.item.type)" v-model="data.value"
                          name="check-button" switch @change="
                            updateDocumentOnToggle(
                              data.item,
                              'file_drop',
                              data.value
                            )
                            " size="lg" class="ml-2" />
                      </template>
                      <template #cell(expiry_date)="data">
                        <span v-html="data.value"></span>
                      </template>
                      <template #cell(expiry_days)="data">
                        <span v-if="data.item.expiry_date !== '-'" :style="data.item.color">{{ data.value }} {{ $t('fileDropPage.daysSuffix') }}</span>
                        <span v-else :style="data.item.color">-</span>
                      </template>
                      <template #cell(action)="data">
                        <svg @click="openDoc(data.item)" class="cursor-pointer mr-4" width="20" height="15"
                          viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <svg @click="downloadDoc(data.item, data.item.pk)" class="mr-4 cursor-pointer" width="20"
                          height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822" stroke="#FFC800" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <!-- <svg @click="editDocument(data.item.id)"
                          v-if="($store.state.user.user.team_member.role === 'Admin' ||
                            $store.state.user.user.team_member.role === 'Operations' || ((data.item.type === 'Vehicle' || data.item.type === 'Trailer') && $store.state.user.user.team_member.role === 'Maintenance Manager')) && !reviewDocs"
                          class="mr-4 cursor-pointer" width="21" height="21" viewBox="0 0 21 21" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                            stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> -->
                        <!-- <svg v-if="checkDeleteDocsStatus(data.item)"
                          @click="showArchivePopup(data.item.pk)" class="cursor-pointer mr-4" width="20" height="17"
                          viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M17.6154 4.40909L17.0385 14.0745C17.0074 14.5955 16.7753 15.0851 16.3897 15.443C16.0041 15.8009 15.4942 16.0002 14.9643 16H5.03569C4.50581 16.0002 3.99589 15.8009 3.6103 15.443C3.22471 15.0851 2.99262 14.5955 2.96154 14.0745L2.38462 4.40909M8.15385 7.81818H11.8462M2.03846 4.40909H17.9615C18.5348 4.40909 19 3.95091 19 3.38636V2.02273C19 1.45818 18.5348 1 17.9615 1H2.03846C1.46523 1 1 1.45818 1 2.02273V3.38636C1 3.95091 1.46523 4.40909 2.03846 4.40909Z"
                            stroke="#FF7900" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        </svg> -->
                        <svg @click="showPopup(data.item.pk)" class="cursor-pointer"
                          v-if="checkDeleteDocsStatus(data.item)" width="19" height="20" viewBox="0 0 19 20" fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path
                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                          <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>

                      </template>
                    </b-table>
                    <div class="entries-pagination px-0 px-sm-2">
                      <div class="d-flex align-items-center flex-wrap">
                        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                          <b-form-select v-model="perPage" :options="pageOptions" />
                        </div>
                        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                          {{ positionText }}
                        </p>
                        <div class="pagination">
                          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                            aria-controls="my-table"></b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <DeleteModal :message="$t('fileDropPage.confirmDelete')" v-if="showDocumentModal"
      @confirm="deleteDocumentItem($event)" />
    <DeleteModal v-if="deleteMultipleDocumentModal" @confirm="deleteDocumentItems($event)"
      :message="$t('fileDropPage.confirmDeleteMultiple', { count: selectedRows.length })" />
    <DeleteModal v-if="showArchivePopupStatus" @confirm="archiveDocument($event)"
      :message="archivedDocs ? $t('fileDropPage.confirmUnarchive') : $t('fileDropPage.confirmArchive')" :updateMessage="true"
      :removeMessage="''" />
    <DeleteModal v-if="showBulkArchivePopupStatus" @confirm="archiveBulkDocuments($event)"
      :message="archivedDocs ? $t('fileDropPage.confirmUnarchiveBulk') : $t('fileDropPage.confirmArchiveBulk')" :updateMessage="true"
      :removeMessage="''" />
    <b-modal id="modal-document" centered no-close-on-backdrop no-close-on-esc size="lg"
      :body-class="'px-3 pt-2 overflow-preview-auto'" :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
      :header-class="'align-items-center'" scrollable>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('fileDropPage.documentModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('fileDropPage.closeModal') }}
        </b-button>
        <b-dropdown id="dropdown-preview" class="load-dropdown mt-0" v-if="editDocumentFlag">
          <template slot="button-content">
            <b-icon class="dots" icon="three-dots"></b-icon>
          </template>
          <b-dropdown-item-button
            :class="(fileName && (!editDocumentFlag) || (editDocumentFlag && checkUpdateDocsStatus())) || checkDeleteDocsStatus(documentData) ? 'mb-2' : ''"
            @click="downloadDoc(documentData, documentData.id)">
            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('fileDropPage.download') }}</p>
          </b-dropdown-item-button>

          <b-dropdown-item-button @click="removeFile()" class="mb-2"
            v-if="fileName && !editDocumentFlag || (editDocumentFlag && checkUpdateDocsStatus())">

            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('fileDropPage.replaceDoc') }}</p>
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="showArchivePopup(documentData.id)" v-if="checkDeleteDocsStatus(documentData)"
            :class="checkDeleteDocsStatus(documentData) ? 'mb-2' : ''">
            <p class="text_secondary cursor-pointer mb-0 f-14"> {{ archivedDocs ? $t('fileDropPage.unarchive') : $t('fileDropPage.archive') }}</p>
          </b-dropdown-item-button>
          <b-dropdown-item-button @click="showPopup(documentData.id)" v-if="checkDeleteDocsStatus(documentData)">
            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('fileDropPage.delete') }}</p>
          </b-dropdown-item-button>
        </b-dropdown>
        <b-dropdown id="dropdown-preview" text="text" class="load-dropdown mt-0" v-if="!editDocumentFlag && fileName">
          <template slot="button-content">
            <b-icon class="dots" icon="three-dots"></b-icon>
          </template>
          <b-dropdown-item-button @click="removeFile()">
            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('fileDropPage.replaceDoc') }}</p>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
      <div class="d-block text-center">
        <b-row>
          <b-col lg="4" md="8" sm="12">
            <div class="text-left mb-3">
              <label class="state">{{ $t('fileDropPage.nameLabel') }}</label>
              <v-select class="bg_white w-100 f-12" v-model="documentData.name" :options="nameOptions" item-value="id"
                item-text="label" :reduce="(option) => option.id" @option:selected="getNameItem($event)"
                @search="searchAssets" :disabled="editDocumentFlag && !checkUpdateDocsStatus()">
                <span slot="no-options">
                  {{ $t('fileDropPage.searchUnitOrName') }}
                </span>
              </v-select>
              <p v-if="errors && errors.name" class="field-error">
                {{ errors.name[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label for="modal-datepicker" class="state">{{ $t('fileDropPage.dateLabel') }}</label>
              <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                @clear="documentData.date = ''" :placeholder="$t('fileDropPage.selectDate')" class="date-picker-custom" :teleport="'body'"
                :disabled="editDocumentFlag && !checkUpdateDocsStatus()"></date-picker>
              <p v-if="errors && errors.date" class="field-error">
                {{ errors.date[0] }}
              </p>
            </div>

            <div class="text-left mb-3">
              <label for="modal-expiry-date" class="state">{{ $t('fileDropPage.expiryDateLabel') }}</label>
              <date-picker v-model="documentData.expiry_date" :formatter="momentFormat" :range-separator="' - '"
                @clear="documentData.expiry_date = ''" :placeholder="$t('fileDropPage.selectDate')" class="date-picker-custom"
                :disabled="editDocumentFlag && !checkUpdateDocsStatus()" :teleport="'body'"></date-picker>
            </div>
            <div class="text-left mb-3" v-if="showDivision">
              <label class="state">{{ $t('fileDropPage.divisionLabel') }}</label>
              <v-select class="f-12" :clearable="false" :options="allDivisions" v-model="documentData.division"
                :disabled="editDocumentFlag && !checkUpdateDocsStatus()" :reduce="(option) => option.id" />
            </div>
            <div class="text-left mb-3" v-if="isTagDoc">
              <label class="state">{{ $t('fileDropPage.tagsLabel') }}</label>
              <v-select class="f-12" :options="docTags" multiple :reduce="(option) => option.id"
                v-model="documentData.tags" :disabled="editDocumentFlag && !checkUpdateDocsStatus()" />
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t('fileDropPage.typeLabel') }}</label>
              <b-form-select class="f-12" :options="getDotOptions" v-model="documentData.doc_type"
                :disabled="editDocumentFlag && !checkUpdateDocsStatus()" @change="setDocDescription($event)">
              </b-form-select>
              <p v-if="errors && errors.doc_type" class="field-error">
                {{ errors.doc_type[0] }}
              </p>
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t('fileDropPage.descriptionLabel') }}</label>
              <b-form-textarea id="textarea" :placeholder="$t('fileDropPage.descriptionPlaceholder')" rows="3" v-model="documentData.description"
                :disabled="editDocumentFlag && !checkUpdateDocsStatus()"></b-form-textarea>
              <p v-if="errors && errors.description" class="field-error pb-4">
                {{ errors.description[0] }}
              </p>
            </div>
            <div class="text-left mb-3" v-if="documentItem && documentItem.source === 'Driver' && documentItem.rejected">
              <div class="text-left mb-2">
                <label for="modal-smart-drop-plus-expiry-date" class="state">{{ $t('fileDropPage.rejectedReasonLabel') }}</label>
                <b-form-input type="text" :placeholder="$t('fileDropPage.rejectedReasonPlaceholder')" v-model="documentItem.rejection_reason"
                  class="unit f-12" disabled></b-form-input>
              </div>
            </div>
            <div class="text-left mb-3">
              <label class="state">{{ $t('fileDropPage.fileDropLabel') }}</label>
              <b-form-checkbox v-model="documentData.file_drop" :disabled="editDocumentFlag && !checkUpdateDocsStatus()"
                name="check-button" switch size="lg" class="ml-0-6rem" />
            </div>
          </b-col>
          <b-col lg="8" sm="12">
            <div class="upload-btn-wrapper" v-if="!fileName">
              <b-img :src="require('@/assets/drop.svg')"></b-img>
              <button v-if="!fileName" class="foo">
                {{ $t('fileDropPage.dropDocument') }}
              </button>
              <button v-else class="foo">{{ fileName }}</button>

              <input ref="docFile" type="file" name="docFile" v-on:change="handleFileUpload"
                accept=".pdf, .png, .jpg, .jpeg" />
              <p v-if="errors && errors.document" class="field-error">
                {{ errors.document[0] }}
              </p>
            </div>
            <div v-else>
              <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf' && media" :src="media"></iframe>
                <div v-else>
                  <div id="panzoom-element" ref="panzoomElement">
                    <img :src="media" class="w-100 h-100 img-section" />
                  </div>
                  <div class="d-flex align-items-center justify-content-center zoom-section">
                    <b-icon @click="zoom(1)" icon="zoom-in" style="fill:white; cursor: pointer;"></b-icon>
                    <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out" style="fill:white;cursor: pointer;"></b-icon>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer="">
        <div class="d-flex modal-footer border-0 p-0 mt-4"
          :class="documentItem && (documentItem.source === 'Driver' && !documentItem.rejected) ? documentData.document_status === 'approved' ? 'justify-content-end' : 'justify-content-between' : 'justify-content-end'">
          <div class="d-flex m-0"
            v-if="documentItem && (documentItem.source === 'Driver' && !documentItem.rejected && documentData.document_status !== 'approved')">
            <b-button class="cancel text-white mr-3" @click="$bvModal.show('modal-reject-doc')"
              variant="danger">{{ $t('fileDropPage.reject') }}</b-button>
          </div>
          <div class="d-flex m-0">
            <b-button class="mx-0 h-40px w-100px m-0" @click="$bvModal.hide('modal-document'); panzoom = null;"
              variant="secondary">{{ editDocumentFlag ? $t('fileDropPage.close') : $t('fileDropPage.cancel') }}</b-button>
            <b-button class="mx-0 mb-0 h-40px w-100px ml-3" variant="primary" @click="sendDocumentData"
              v-if="hasChanged && (!editDocumentFlag || (editDocumentFlag && checkUpdateDocsStatus() && (!documentData.uploaded_by_driver || (documentData.uploaded_by_driver && documentData.document_status === 'approved'))))">{{ $t('fileDropPage.save') }}</b-button>
            <b-button class="btn save mx-0 ml-3"
              v-if="(editDocumentFlag && checkUpdateDocsStatus() && documentData.uploaded_by_driver && documentData.document_status !== 'approved')"
              @click="sendDocumentData(true)" variant="primary">{{ $t('fileDropPage.approve') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <DriverAndPublicShare :title="sharePopupTitle" @updateDocs="getAllDocs()" v-if="selectedRows.length"
      :docIds="selectedRows.map((data) => data.pk)"
      @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false" />
    <BulkDocTypeUpdate @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :docIds="selectedRows.map((data) => data.pk)" v-if="selectedRows.length" @updateDocs="getAllDocs()"
      :modelType="selectedRows[0].type" />
    <BulkDotModeUpdate @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :docIds="selectedRows.map((data) => data.pk)" v-if="selectedRows.length" @updateDocs="getAllDocs()" />
    <TableColumns :showColumns="showColumns" :fields="fields" @getUpdatedFieldsList="getUpdatedFieldsList($event)"
      @updateFields="updateFields($event)" @resetTableFields="resetTableFields()" @resetData="showColumns = false" />
    <BulkExpiryDateUpdate @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :docIds="selectedRows.map((data) => data.pk)" v-if="selectedRows.length" @updateDocs="getAllDocs()" />
    <BulkUpdateDescription @close="$refs.tableRef.clearSelected(); selectedRows = []; allRowsSelected = false"
      :docIds="selectedRows.map((data) => data.pk)" v-if="selectedRows.length" @updateDocs="getAllDocs()" />
    <RejectDoc :documentItem="documentItem" :documentData="documentData"
      @docRejected="$bvModal.hide('modal-document'); panzoom = null; getAllDocs()" />
    <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
      :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t('fileDropPage.filtersModalTitle') }}
        </h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('fileDropPage.closeModal') }}
        </b-button>
      </template>
      <div class="body">
        <b-form-group :label="$t('fileDropPage.filterDocType')" class="text-left select_arrow label w-equipment-box bg-white">
          <b-form-select v-model="filterFields.doc_type" class="f-12 bg-white" @change="getAllDocs()"
            :options="docTypeOptions" />
        </b-form-group>
        <b-form-group :label="$t('fileDropPage.filterSource')" class="text-left select_arrow label w-equipment-box bg-white">
          <b-form-select v-model="filterFields.source" class="f-12 bg-white" @change="getAllDocs()" :options="sourceOptions" />
        </b-form-group>
        <b-form-group :label="$t('fileDropPage.filterTags')" class="text-left w-equipment-box mb-3">
          <v-select multiple class="f-12 bg-grey" :options="allTags" :reduce="(option) => option.id"
            v-model="filterFields.tags" @input="getAllDocs()" />
        </b-form-group>
      </div>
      <template #modal-footer="">
        <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
          <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
            @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('fileDropPage.reset') }}</b-button>
          <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{ $t('fileDropPage.close') }}</b-button>
        </div>
      </template>
    </b-modal>
    <DeleteModal
      :message="$t('fileDropPage.fileDropOffWarning')"
      :updateMessage="true" :removeMessage="''" v-if="showWarningMessage" @confirm="updateWarningMessage" />
  </div>
</template>
<script>
import * as moment from "moment-timezone";
import DeleteModal from "@/components/DeleteModal.vue";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import DriverAndPublicShare from "@/components/Documents/DriverAndPublicShare.vue";
import BulkDocTypeUpdate from "@/components/Documents/BulkDocTypeUpdate.vue";
import BulkDotModeUpdate from "@/components/Documents/BulkDotModeUpdate.vue";
import BulkExpiryDateUpdate from "@/components/Documents/BulkExpiryDateUpdate.vue";
import TableColumns from "@/components/Shared/TableColumns.vue";
import { checkValueExists, checkDescriptionLength, getMediaType, getFileExtension, detectMimeFromBytes } from "../../services/helper";
import JSZip from "jszip"
import Panzoom from '@panzoom/panzoom'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import BulkUpdateDescription from "@/components/Documents/BulkUpdateDescription.vue";
import RejectDoc from "@/components/Documents/RejectDoc.vue";
export default {
  name: "Documents",
  components: { DeleteModal, vSelect, DriverAndPublicShare, BulkDocTypeUpdate, BulkDotModeUpdate, TableColumns, BulkExpiryDateUpdate, DatePicker, BulkUpdateDescription, RejectDoc },
  data() {
    return {
      momentFormat: {
        stringify: (date) => {
          return date ? moment(date).format('ll') : ''
        },
        parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
      },
      checkDescriptionLength,
      showColumns: false,
      fileDrop: 'sent',
      checkValueExists,
      searchName: null,
      userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      searchType: null,
      panzoom: null,
      currentPage: 1,
      sortBy: undefined,
      isTableMounted: false,
      documentItem: null,
      defaultData: {},
      showDocumentProgess: null,
      sortDesc: undefined,
      showDocumentUploadStatus: null,
      emptyTable: false,
      showArchivePopupStatus: false,
      showBulkArchivePopupStatus: false,
      archivedDocs: false,
      isBusy: false,
      rows: 1,
      media: null,
      mediaType: null,
      inlineMedia: null,
      mediaID: null,
      docName: "",
      positionText: "",
      sharePopupTitle: "",
      allRowsSelected: false,
      searchDescription: null,
      showDocumentModal: false,
      deleteMultipleDocumentModal: false,
      itemId: null,
      searchDays: null,
      fileName: null,
      bulkFileUploadFileName: '',
      editDocumentFlag: false,
      items: [],
      showDivision: false,
      showPublic: false,
      modelType: null,
      isTagDoc: false,
      archivedDocsCount: 0,
      sendCount: 0,
      receivedCount: 0,
      perPage: 25,
      selectedRows: [],
      allTags: [],
      docTags: [],
      pageOptions: [
        {
          value: 10,
          text: "10",
        },
        {
          value: 25,
          text: "25",
        },
        {
          value: 50,
          text: "50",
        },
        {
          value: 100,
          text: "100",
        },
      ],
      fields: [],
      filterFields: {
        search_field: '',
        type: '',
        doc_type: '',
        expiry_days: '',
        uploaded_by_driver: '',
        source: '',
        tags: []
      },
      showWarningMessage: false,
      documentData: {
        name: null,
        object_id: null,
        date: new Date(),
        type: null,
        document: null,
        description: null,
        expiry_date: "",
        file_drop: true,
        doc_type: "",
        division: null,
        tagged_model: "-",
        tags: []
      },
      bulkUploadDocumentData: {
        document: null,
        model: "",
        doc_type: ""
      },
      errors: {
        date: null,
        name: null,
        document: null,
        description: null,
      },
      nameOptions: [],
    };
  },
  computed: {
    ...mapGetters(["allCompanyDocs", "company", "allDrivers", "allEquipments", "userCompany", "docTypeItems", 'defaultDocType', 'divisions', 'rolePermissions', 'userPreferences', 'user', 'tags']),
    showReviewSection() {
      return this.rolePermissions && this.rolePermissions['Document'] && this.rolePermissions['Document'][0].allow
    },
    allowUpdateDocDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][8].allow
    },
    allowUpdateDocEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][7].allow
    },
    allowUpdateDocCompany() {
      return this.rolePermissions && this.rolePermissions['Company Documents'] && this.rolePermissions['Company Documents'][1].allow
    },
    allowCreateDocDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][9].allow
    },
    allowCreateDocEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][8].allow
    },
    allowCreateDocCompany() {
      return this.rolePermissions && this.rolePermissions['Company Documents'] && this.rolePermissions['Company Documents'][2].allow
    },
    allowDeleteDocDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][10].allow
    },
    allowDeleteDocEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][9].allow
    },
    allowDeleteDocCompany() {
      return this.rolePermissions && this.rolePermissions['Company Documents'] && this.rolePermissions['Company Documents'][3].allow
    },
    allowViewDocDrivers() {
      return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][7].allow
    },
    allowViewDocEquipment() {
      return this.rolePermissions && this.rolePermissions['Equipment'] && this.rolePermissions['Equipment'][6].allow
    },
    allowViewDocCompany() {
      return this.rolePermissions && this.rolePermissions['Company Documents'] && this.rolePermissions['Company Documents'][0].allow
    },
    allDivisions() {
      return this.divisions.map((item) => {
        return {
          id: item.id,
          label: item.division,
        }
      })
    },
    hasChanged() {
      return Object.keys(this.documentData).filter(field => {
        if (field !== 'updated_at') {
          if (typeof this.documentData[field] === 'object') return JSON.stringify(this.documentData[field]) !== JSON.stringify(this.defaultData[field])
          if (field === 'description') {
            return this.checkValueExists(this.documentData[field]?.trim().replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultData[field]?.trim().replace(/\r\n|\r|\n/g, '\n'));
          }
          else if (!this.documentData[field] && !this.defaultData[field]) return false
          else return this.checkValueExists(this.documentData[field]) != this.checkValueExists(this.defaultData[field])
        } return false
      }).length > 0
    },
    docTypeOptions() {
      const items = [{
        value: "",
        text: ""
      }]
      this.docTypeItems.map((item) => {
        items.push({
          value: item.id,
          text: item.type
        }
        )
      })
      return items
    },
    getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model !== 'Company').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
    getBulkDotOptions() {
      return [...[{
        value: "",
        text: "",
      }], ...this.docTypeItems?.filter((item) => item.model === this.bulkUploadDocumentData.model || item.model === 'All').map((item) => {
        return {
          value: item.id,
          text: item.type,
        }
      })]
    },
    activeFiltersCount() {
      return Object.keys(this.filterFields).reduce((count, key) => {
        if (key === 'tags') {
          return count + (this.filterFields.tags.length > 0 ? 1 : 0);
        }
        else if (
          this.filterFields[key] !== '' &&
          this.filterFields[key] !== null
        ) {
          return count + 1;
        }
        return count;
      }, 0);
    },
    visibleFields() {
      return this.fields.filter(field => field.visible)
    },
    sourceOptions() {
      return [
        { value: '', text: '-' },
        { value: 'uploaded_by_driver', text: this.$t('fileDropPage.filterSourceDriver') },
      ];
    },
    typeOptions() {
      const options = [
        {
          value: "",
          text: "",
        },
      ];
      if (this.allowViewDocEquipment) {
        options.push({
          value: "Vehicle",
          text: "Vehicle",
        })
        options.push(
          {
            value: "Trailer",
            text: "Trailer",
          })
      }
      if (this.allowViewDocDrivers) {
        options.push({
          value: "Driver",
          text: "Driver",
        });
      }
      if (this.allowViewDocCompany) {
        options.push({
          value: "Company",
          text: "Company",
        });
        options.push({
          value: "Tag Doc",
          text: "Tag Doc",
        });
      }
      return options;
    }
  },
  methods: {
    ...mapActions([
      "getCompanyDocs",
      "setLoader",
      "retrieveDocument",
      "deleteCompanyDocument",
      "setNotification",
      "updateTeamMemberDocument",
      "getFilteredDrivers",
      "getFilteredEquipments",
      "sendCompanyDocuments",
      "sendBulkCompanyDocuments",
      "checkBulkCompanyDocumentsUploadStatus",
      "updateBulkCompanyDocumentsUploadStatus",
      "bulkUpdateDocTypeItems",
      "updateUserPreferences",
      "deleteUserPreferences",
      "updateBulkDocument",
      "getAllTags"
    ]),
    setShowWarningMessage(e) {
      if (!e) {
        this.showWarningMessage = true
      }
    },
    updateWarningMessage(status) {
      if (!status) {
        this.documentData.file_drop = true
        this.showWarningMessage = false
      }
      else {
        this.documentData.file_drop = false
        this.showWarningMessage = false
      }
    },
    async getDocumentUploadStatus() {
      if (this.rolePermissions && this.rolePermissions['Document'] && this.rolePermissions['Document'][2].allow) {
        const data = await this.checkBulkCompanyDocumentsUploadStatus()
        if (data.status === 'In Progress') this.showDocumentProgess = data
        if ((data.status === 'Completed' || data.status === 'Failed') && !data.dismissed && data.requestor === 2) this.showDocumentUploadStatus = data
      }
    },
    showArchivePopup(docId) {
      this.showArchivePopupStatus = true
      this.itemId = docId
    },
    showBulkArchivePopup() {
      const uniqueTypes = [...new Set(this.selectedRows.map((item) => {
        if (item.type === 'Vehicle' || item.type === 'Trailer') return { type: 'Equipment' }
        return { type: item.type }
      }))];
      let archivePermission = true
      for (let type of uniqueTypes) {
        if (!this.checkDeleteDocsStatus(type)) {
          this.setNotification({
            msg: this.$t('fileDropPage.noPermArchive', { type: type.type }),
            type: "error",
            color: "red",
          });
          archivePermission = false
          break
        }

      }
      if (archivePermission) {
        this.showBulkArchivePopupStatus = true
      }
    },
    async archiveBulkDocuments(status) {
      if (status) {
        try {
          await this.updateBulkDocument({
            ids: this.selectedRows.map((data) => data.pk),
            is_archived: !this.archivedDocs
          });
          this.showBulkArchivePopupStatus = false
          await this.setNotification({
            msg: this.archivedDocs ? this.$t('fileDropPage.docsUnarchived') : this.$t('fileDropPage.docsArchived'),
            type: "success",
            color: "green",
          });
          this.$refs.tableRef.clearSelected();
          this.selectedRows = [];
          this.allRowsSelected = false
          this.getAllDocs()
        }
        catch (e) {
          this.showBulkArchivePopupStatus = false
          this.$refs.tableRef.clearSelected();
          this.selectedRows = [];
          this.allRowsSelected = false
          console.log(e)
        }
      }
      else {
        this.showBulkArchivePopupStatus = false
        this.$refs.tableRef.clearSelected();
        this.selectedRows = [];
        this.allRowsSelected = false
      }
    },
    async archiveDocument(status) {
      if (status) {
        try {
          const data = this.items.filter(
            (item) => this.itemId === item.pk
          )[0];
          delete data.tags
          await this.updateTeamMemberDocument({
            id: data.pk,
            payload: { ...data, is_archived: !this.archivedDocs, date: moment(data.date).format("YYYY-MM-DD"), expiry_date: data.expiry ? moment(data.expiry).format("YYYY-MM-DD") : null, object_id: data.object_id },
          });
          this.showArchivePopupStatus = false
          this.itemId = null
          this.$bvModal.hide("modal-document");
          await this.setNotification({
            msg: this.archivedDocs ? this.$t('fileDropPage.docUnarchived') : this.$t('fileDropPage.docArchived'),
            type: "success",
            color: "green",
          });
          this.getAllDocs()
        }
        catch (e) {
          this.showArchivePopupStatus = false
          this.itemId = null
          console.log(e)
        }
      }
      else {
        this.showArchivePopupStatus = false
        this.itemId = null
      }
    },
    async resetTableFields() {
      try {
        this.setLoader(true)
        await this.deleteUserPreferences(`File Drop/`)
        this.showColumns = false
        this.setLoader(false)
      }
      catch (e) {
        this.setLoader(false)
        console.log(e)
      }
    },
    async getUpdatedFieldsList(updatedFields) {
      this.fields = updatedFields
      try {
        const updatedOrderList = updatedFields.map((item, index) => {
          return { ...item, display_order: index + 1 }
        })
        await this.updateUserPreferences({
          "columns": updatedOrderList
        })
      }
      catch (e) {
        console.log(e)
      }
    },
    checkDriverShare() {
      const uniqueTypes = [...new Set(this.selectedRows.map(item => item.type))];
      let updatePermission = true
      for (let type of uniqueTypes) {
        if (!this.checkUpdateStatus(type)) {
          this.setNotification({
            msg: this.$t('fileDropPage.noPermUpdate', { type }),
            type: "error",
            color: "red",
          });
          updatePermission = false
          break
        }
      }
      if (updatePermission) {
        this.sharePopupTitle = this.$t('fileDropPage.driverShare');
        this.$bvModal.show('modal-driver-public-share')
      }
    },
    checkDotMode() {
      const uniqueTypes = [...new Set(this.selectedRows.map(item => item.type))];
      let updatePermission = true
      for (let type of uniqueTypes) {
        if (!this.checkUpdateStatus(type)) {
          this.setNotification({
            msg: this.$t('fileDropPage.noPermUpdate', { type }),
            type: "error",
            color: "red",
          });
          updatePermission = false
          break
        }
      }
      if (updatePermission) {
        this.$bvModal.show('modal-bulk-dot-mode-update')
      }
    },
    setExpiryDate() {
      this.$bvModal.show('modal-bulk-expiry-date-update')
    },
    checkBulkDeleteDocumentsStatus() {
      const uniqueTypes = [...new Set(this.selectedRows.map((item) => {
        if (item.type === 'Vehicle' || item.type === 'Trailer') return { type: 'Equipment' }
        return { type: item.type }
      }))];
      let deletePermission = true
      for (let type of uniqueTypes) {
        if (!this.checkDeleteDocsStatus(type)) {
          this.setNotification({
            msg: this.$t('fileDropPage.noPermDelete', { type: type.type }),
            type: "error",
            color: "red",
          });
          deletePermission = false
          break
        }

      }
      if (deletePermission) {
        this.deleteMultipleDocumentModal = true
      }
    },
    checkDeleteDocsStatus(data) {
      if (data.type === 'Driver' && this.allowDeleteDocDrivers) return true
      else if (data.type === 'Tag Doc' && this.allowDeleteDocCompany) return true
      else if (data.type === 'Company' && this.allowDeleteDocCompany) return true
      else if ((data.type === 'Equipment' || data.type === 'Vehicle' || data.type === 'Trailer') && this.allowDeleteDocEquipment) return true
      else if (!data.type && this.allowDeleteDocEquipment) return true
      else return false
    },
    checkUpdateDocsStatus() {
      if (this.documentData) return this.checkUpdateStatus(this.documentData.type)
      return false
    },
    checkUpdateStatus(type) {
      if (type === 'Driver' && this.allowUpdateDocDrivers) return true
      else if (type === 'Tag Doc' && this.allowUpdateDocCompany) return true
      else if (type === 'Company' && this.allowUpdateDocCompany) return true
      else if ((type === 'Equipment' || type === 'Vehicle' || type === 'Trailer') && this.allowUpdateDocEquipment) return true
      else return false
    },
    zoom(level) {
      if (!this.panzoom) {
        this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
          maxScale: 5
        })
      }
      level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
    },
    getExtensionFromMimeType(mimeType) {
      const mimeMap = {
        'application/pdf': 'pdf',
        'image/jpeg': 'jpg',
        'image/png': 'png',
      };

      return mimeMap[mimeType] || '';
    },
    async downloadBulkFiles() {
      this.setLoader(true);
      const zip = new JSZip();
      const fileNameMap = new Map(); // Tracks filenames to prevent duplicates

      const promises = this.selectedRows.map(async (doc) => {
        try {
          const { document } = await this.retrieveDocument(doc.pk);
          if (!document) throw new Error("No document URL found");

          const response = await fetch(document);
          if (!response.ok) {
            throw new Error(`Failed to fetch document: ${response.status}`);
          }

          const blob = await response.blob();
          const extension = this.getExtensionFromMimeType(blob.type) || 'bin';

          // Build base filename
          let baseName = `${doc.name}-${doc.description || ''}${doc.expiry ? `-${moment(doc.expiry).format("YYYY-MM-DD")}` : ''}`;
          baseName = baseName.replace(/[\\?%*:|"<>]/g, "_");

          let fileName = `${baseName}.${extension}`;

          // Ensure uniqueness by appending -1, -2, etc.
          if (fileNameMap.has(fileName)) {
            let count = fileNameMap.get(fileName) + 1;
            let newFileName;
            do {
              newFileName = `${baseName}-${count}.${extension}`;
              count++;
            } while (fileNameMap.has(newFileName));
            fileName = newFileName;
            fileNameMap.set(fileName, 1);
          } else {
            fileNameMap.set(fileName, 1);
          }

          zip.file(fileName, blob);
        } catch (err) {
          console.error(`❌ Error processing pk=${doc.pk}`, err);
          zip.file(`ERROR-${doc.pk}.txt`, `Failed to process document with pk=${doc.pk}\nReason: ${err.message}`);
        }
      });

      try {
        await Promise.all(promises);
        const content = await zip.generateAsync({ type: "blob" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(content);
        link.download = `${this.company[0].name}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (zipError) {
        console.error("❌ Failed to create ZIP:", zipError);
      } finally {
        this.$refs.tableRef.clearSelected();
        this.allRowsSelected = false;
        this.setLoader(false);
      }
    },
    async showPublicShare() {
      const allEquipments = this.selectedRows.every(obj => obj.type === "Trailer" || obj.type === "Vehicle");
      if (allEquipments) {
        this.sharePopupTitle = this.$t('fileDropPage.publicShare');
        this.$bvModal.show('modal-driver-public-share')
      }
      else {
        await this.setNotification({
          msg: this.$t('fileDropPage.onlyEquipmentDocs'),
          type: "error",
          color: "red",
        });
      }
    },
    async downloadDoc(data, id) {
      this.setLoader(true)
      const doc = await this.retrieveDocument(id);
      fetch(doc.document)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then(blob => {
          const newUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = newUrl;
          const urlWithoutParams = doc.document.split('?')[0];
          const extension = urlWithoutParams.split('.').pop();
          a.download = `${data.docName ? data.docName : data.name}-${data.description ? data.description.replace(/\./g, '') : ''}.${extension}`
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(newUrl);
          a.remove()
          this.setLoader(false)
        })
        .catch(error => {
          this.setLoader(false)
          console.log(error)
        });
    },
    async checkDocType() {
      const allSameType = this.selectedRows.every(obj => obj.type === this.selectedRows[0].type);
      if (allSameType) {
        if (this.checkUpdateStatus(this.selectedRows[0].type)) {
          this.$bvModal.show('modal-bulk-doc-type')
        }
        else {
          await this.setNotification({
            msg: this.$t('fileDropPage.noPermAction'),
            type: "error",
            color: "red",
          });
        }
      } else {
        await this.setNotification({
          msg: this.$t('fileDropPage.sameModelRequired'),
          type: "error",
          color: "red",
        });
      }
    },
    setDocDescription(event) {
      if (event) {
        this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
      }
      else this.documentData.description = this.defaultData.description
    },
    async dimissUploadStatus() {
      try {
        this.setLoader(true)
        await this.updateBulkCompanyDocumentsUploadStatus({
          id: this.showDocumentUploadStatus.id,
          payload: { dismissed: true }
        })
        await this.setNotification({
          msg: this.$t('fileDropPage.dismissed'),
          type: "success",
          color: "green",
        });
        this.showDocumentUploadStatus = null
        this.setLoader(false)
      }
      catch (e) {
        this.setLoader(false)
        console.log(e)

      }
    },
    async resetFilterFields() {
      this.filterFields = {
        search_field: '',
        type: '',
        doc_type: '',
        expiry_days: '',
        uploaded_by_driver: '',
        source: '',
        tags: []
      }
      await this.getAllDocs();
    },
    async updateFields(updatedFields) {
      this.fields = updatedFields
      this.filterFields = {
        search_field: '',
        type: '',
        doc_type: '',
        expiry_days: '',
        uploaded_by_driver: '',
        source: '',
        tags: []
      }
      try {
        await this.updateUserPreferences({
          "columns": updatedFields
        })
        await this.getAllDocs();
      }
      catch (e) {
        console.log(e)
      }
      await this.getAllDocs();
    },
    onRowSelected(items) {
      this.selectedRows = items
    },
    selectRows(checked) {
      if (checked) {
        this.$refs.tableRef.selectAllRows()
      }
      else {
        this.$refs.tableRef.clearSelected()
        this.allRowsSelected = false
      }
    },
    checked(index, checked) {
      let tableRef = this.$refs.tableRef
      if (checked === true) tableRef.selectRow(index)
      else tableRef.unselectRow(index)
    },
    downloadFile(uri) {
      axios({
        method: 'get',
        url: uri,
        responseType: 'blob',
      }).then(response => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const urlWithoutParams = uri.split('?')[0];
        const extension = urlWithoutParams.split('.').pop();
        a.download = this.docName + "." + extension
        document.body.appendChild(a);
        a.click();
        a.remove()
        window.URL.revokeObjectURL(url);
      });
    },
    handleFileUpload() {
      this.documentData.document = this.$refs.docFile.files[0];
      this.fileName = this.documentData.document.name;
      this.media = URL.createObjectURL(this.documentData.document);
      if (this.$refs.docFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
      else this.mediaType = 'image'
    },
    async openDoc(data) {
      this.docName = `${data.name}-${data.description ? data.description.replace(/\./g, '') : ''}`
      this.revokeInlineMedia()
      // Pointing the viewer at an extension-less link makes the browser download it, so the
      // source is left empty until the real type is resolved from the file content.
      const hasExtension = !!getFileExtension(data.link)
      this.media = hasExtension ? data.link : null
      this.mediaID = data.pk
      this.mediaType = getMediaType(data.link)
      this.documentItem = data
      this.editDocument(data.id, data.name)
      if (!hasExtension) await this.previewFromContent(data.link)
    },
    // Extension-less uploads are served as binary/octet-stream, which the browser downloads
    // instead of rendering, so the file is re-wrapped in a blob with its real type.
    async previewFromContent(link) {
      try {
        const response = await fetch(link);
        if (!response.ok) throw new Error(`Failed to fetch document: ${response.status}`);
        const buffer = await response.arrayBuffer();
        const mimeType = detectMimeFromBytes(buffer) || 'application/pdf';
        this.inlineMedia = URL.createObjectURL(new Blob([buffer], { type: mimeType }));
        this.media = this.inlineMedia;
        this.mediaType = mimeType === 'application/pdf' ? 'pdf' : 'image';
      } catch (error) {
        console.log(error);
      }
    },
    revokeInlineMedia() {
      if (this.inlineMedia) {
        URL.revokeObjectURL(this.inlineMedia);
        this.inlineMedia = null;
      }
    },
    getNameItem(item) {
      this.showDivision = item.type === 'company' ? true : false
      this.showPublic = item.type !== "teammember" ? true : false
      this.isTagDoc = item.type == 'Tag Doc'
      this.modelType = item.model
      if (this.showDivision) this.documentData.division = this.divisions.filter((division) => division.default)[0]?.id
      if (this.isTagDoc) {
        this.documentData['tagged_model'] = '-'
        this.documentData['tags'] = []
      }
    },
    async searchAssets(searchText) {
      if (searchText) {
        let options = []
        let equipmentRecords
        if ((this.allowUpdateDocEquipment && this.editDocumentFlag) || this.allowCreateDocEquipment) {
          equipmentRecords = await this.getFilteredEquipments({ unit_no: searchText });
        }
        if (((this.allowUpdateDocDrivers && this.editDocumentFlag) || this.allowCreateDocDrivers) && ((((!this.allowUpdateDocEquipment && this.editDocumentFlag) && !this.allowCreateDocEquipment)) || (equipmentRecords && equipmentRecords.length === 0))) {
          const driverRecords = await this.getFilteredDrivers(searchText);
          if (driverRecords.length) {
            driverRecords.map((item) => {
              options.push({
                id: `Driver-${item.id}`,
                label: item.name,
                type: "teammember",
                name: `${item.name}_`,
                model: "Driver"
              });
            });
          }
        }
        else {
          if (equipmentRecords) {
            equipmentRecords.map((item) => {
              options.push({
                id: `${item.type}-${item.id}`,
                label: item.unit_no,
                type: "equipment",
                name: `${item.unit_no}_`,
                model: item.type
              });
            });
          }
        }
        if (this.allowUpdateDocCompany) {
          this.nameOptions = this.nameOptions.concat(options).concat([{
            id: `Company-${this.userCompany}`,
            label: "Company",
            type: "company",
            name: this.company[0].name,
            model: "Company"
          },
          {
            id: `CompanyTagDoc-${this.userCompany}`,
            label: "Tag Doc",
            type: "Tag Doc",
            name: this.company[0].name,
            model: "Company"
          }
          ])
        }
        else this.nameOptions = options
        this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
      }
    },
    checkNullValues(payload) {
      let nullKeys = [];
      for (let [key, value] of Object.entries(payload)) {
        if (!value) {
          nullKeys.push(key);
        }
      }
      return nullKeys;
    },
    extractFilePath(url) {
      const pathname = new URL(url).pathname;

      return pathname.substring(pathname.indexOf("documents/"));
    },
    async sendDocumentData(approveDocs = false) {
      try {
        if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
          throw {
            description: [this.$t('fileDropPage.descriptionMaxLength')],
          };
        }
        if (!this.documentData.file_drop) {
          const currentDocType = this.docTypeItems.filter((item) => item.id === this.documentData.doc_type)[0]
          if (currentDocType && currentDocType.model !== this.modelType) {
            await this.setNotification({
              msg: this.$t('fileDropPage.docTypeInvalid'),
              type: "error",
              color: "red",
            });
            return
          }
        }
        const nullKeys = this.checkNullValues({
          name: this.documentData.name,
          date: this.documentData.date,
          document: this.documentData.document,
          ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {}
        });
        if (nullKeys.length === 0) {
          this.setLoader(true);
          let formData = new FormData();
          let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
          if (!fileType) this.documentData.document = null
          const modelType = this.nameOptions.filter(
            (item) => item.id === this.documentData.name
          )[0].type
          formData.append("object_id", this.documentData.name.split("-")[1]);
          formData.append(
            "date",
            moment(this.documentData.date).format("YYYY-MM-DD")
          );
          formData.append("description", this.documentData.description);
          if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
          formData.append("type", this.documentData.type);
          formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
          if (approveDocs) formData.append("rejected", false)
          if (this.documentData.document)
            formData.append(
              "document",
              new File(
                [this.documentData.document],
                this.nameOptions.filter(
                  (item) => item.id === this.documentData.name
                )[0].name + "_" +
                this.documentData.description +
                "_" + this.userCompany + "_" +
                new Date().getTime() +
                "." +
                this.documentData.document["type"].split("/").pop(),
                { type: this.documentData.document["type"] }
              )
            );
          formData.append("file_drop", this.documentData.file_drop);
          formData.append(
            "model_type",
            modelType === 'Tag Doc' ? 'company' : modelType
          );
          if (this.nameOptions.filter(
            (item) => item.id === this.documentData.name
          )[0].type === 'company') formData.append("division", this.documentData.division);
          formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
          if (this.isTagDoc) {
            formData.append("unattached", true);
            formData.append("tagged_model", this.documentData.tagged_model);
            this.documentData.tags.forEach((tag) => {
              formData.append("tags", tag);
            })
          }
          if (this.editDocumentFlag) {
            this.documentData = await this.updateTeamMemberDocument({
              id: this.documentData.id,
              payload: formData,
            });
            await this.setNotification({
              msg: this.$t('fileDropPage.docUpdated'),
              type: "success",
              color: "green",
            });
            this.$bvModal.hide("modal-document");
            let color;
            let expiryColor;
            let daysDiff = "-";
            if (this.documentData.expiry_date) {
              const currentDate = new Date();
              const expiryDate = new Date(this.documentData.expiry_date);
              const diffDays = parseInt(
                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                10
              );
              if (diffDays > 30) {
                color = "color:black";
              } else if (diffDays <= 30 && diffDays >= 1) {
                color = "color:#FFC800";
              } else color = "color:#FF0000";
              daysDiff = parseInt(
                (new Date(this.documentData.expiry_date) - new Date()) /
                (1000 * 60 * 60 * 24),
                10
              );
              if (daysDiff <= 0) {
                expiryColor = "color:red";
              } else if (daysDiff <= 30 && daysDiff >= 1) {
                expiryColor = "color:#FFC800";
              } else {
                expiryColor = "color:green";
              }
              this.allCompanyDocs[this.documentIndex] = this.documentData;
              this.allCompanyDocs[this.documentIndex] = { ...this.documentData, doc_type: this.documentData.doc_type, document: this.extractFilePath(this.documentData.document) };
              this.items[this.documentIndex].Date = moment(
                this.documentData.date
              ).format("ll");
              this.items[this.documentIndex].type = this.documentData.type;
              this.items[this.documentIndex].Description =
                this.documentData.description;
              this.items[this.documentIndex].expiry_date = this.documentData
                .expiry_date
                ? `<span style=${color}>${moment(
                  this.documentData.expiry_date
                ).format("ll")}</span`
                : "-";
              this.items[this.documentIndex].file_drop = this.documentData.file_drop;
              this.items[this.documentIndex].Days = daysDiff;
              this.items[this.documentIndex].color = expiryColor;
              this.editDocumentFlag = false;
            }
          } else {
            await this.sendCompanyDocuments(formData);
            this.$bvModal.hide("modal-document");
            await this.setNotification({
              msg: this.$t('fileDropPage.docAdded'),
              type: "success",
              color: "green",
            });
          }
          this.getAllDocs();
          this.documentData = {
            object_id: null,
            date: null,
            name: null,
            type: null,
            document: null,
            description: null,
            expiry_date: "",
            file_drop: true,
            doc_type: "",
            division: null,
            tagged_model: "-",
            tags: []
          };
          this.fileName = null;
          this.nameOptions = []
          this.setLoader(false);
        }
        else {
          let error = {};
          nullKeys.forEach((x) => {
            error[x] = [this.$t('fileDropPage.fieldRequired')];
          });
          throw error;
        }
      } catch (error) {
        this.setLoader(false);
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
      }

    },
    removeFile() {
      this.fileName = null;
      this.documentData.document = null
      this.revokeInlineMedia()
      this.media = null
      this.mediaType = null
    },
    addDocument() {
      this.$bvModal.show("modal-document");
      this.nameOptions = []
      this.defaultData = {}
      this.fileName = null;
      this.showDivision = false
      this.showPublic = false
      this.editDocumentFlag = false;
      this.isTagDoc = false;
      this.documentData = {
        name: null,
        object_id: null,
        date: new Date(),
        type: null,
        document: null,
        description: null,
        expiry_date: "",
        file_drop: true,
        doc_type: "",
        division: null,
        tagged_model: "-",
        tags: []
      };
      this.errors = {
        date: null,
        name: null,
        document: null,
        description: null,
        ...this.company[0].doc_type ? { doc_type: null } : {}
      };
    },
    async openLink(id) {
      const doc = await this.retrieveDocument(id);
      window.open(doc.document, "_blank");
    },
    async deleteDocumentItem(item) {
      if (item) {
        try {
          this.setLoader(true)
          await this.deleteDocument(this.itemId);
          this.documentItem = null
          this.setLoader(false)
        }
        catch (e) {
          this.setLoader(false)
        }
      }
      this.showDocumentModal = false;
    },
    async approveDocs() {
      let acceptedDocs = 0
      this.selectedRows.map(async (item) => {
        if (item.name !== '-') acceptedDocs++
      })
      if (acceptedDocs !== this.selectRows.length) {
        await this.setNotification({
          msg: this.$t('fileDropPage.allNeedName'),
          type: "error",
          color: "red",
        });
        return
      }
      this.setLoader(true)
      await Promise.all(
        this.selectedRows.map(async (data) => {
          await this.updateTeamMemberDocument({
            id: data.pk,
            payload: { ...data, ...data.source === 'BOT' ? { data_extraction_successful: true } : { rejected: false }, date: moment(data.date).format("YYYY-MM-DD"), expiry_date: data.expiry ? moment(data.expiry).format("YYYY-MM-DD") : null, object_id: data.object_id },
          });
        })
      ).then(async () => {
        this.setLoader(false)
        await this.setNotification({
          msg: this.$t('fileDropPage.docUpdatedToast'),
          type: "success",
          color: "green",
        });
        await this.getAllDocs();
        this.$refs.tableRef.clearSelected()
        this.allRowsSelected = false
      }).catch(async (e) => {
        this.setLoader(false)
        await this.setNotification({
          msg: e,
          type: "error",
          color: "red",
        });
      })
    },
    async deleteDocumentItems(item) {
      if (item) {
        this.setLoader(true)
        await Promise.all(
          this.selectedRows.map(async (item) => {
            await this.deleteDocument(item.pk, false);
          })
        ).then(async () => {
          this.setLoader(false)
          await this.getAllDocs();
          this.$refs.tableRef.clearSelected()
          this.allRowsSelected = false
          this.deleteMultipleDocumentModal = false;
        }).catch(async (e) => {
          this.setLoader(false)
          await this.setNotification({
            msg: e,
            type: "error",
            color: "red",
          });
        })
      }
      else {
        this.deleteMultipleDocumentModal = false
        this.$refs.tableRef.clearSelected();
        this.allRowsSelected = false
        this.selectedRows = []
      }
    },
    showPopup(id) {
      this.showDocumentModal = true;
      this.itemId = id;
    },
    async deleteDocument(id, refreshDocs = true) {
      try {
        await this.deleteCompanyDocument(`${id}/?company_id=${this.userCompany}`);
        if (refreshDocs) await this.getAllDocs();
        await this.setNotification({
          msg: this.$t('fileDropPage.docDeleted'),
          type: "success",
          color: "green",
        });
        this.$bvModal.hide("modal-document");
      } catch (error) {
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    editDocument(id, name) {
      const data = this.items.filter(
        (item) => item.pk === this.allCompanyDocs[id].id
      )[0];
      this.nameOptions = [{
        id: `${data.type}-${data.type === "Company" ? this.userCompany : data.userID}`,
        label: data.name,
        type: `${data.type === "Company" || data.type === "Tag Doc" ? 'company' : data.type === "Vehicle" || data.type === "Trailer" ? 'equipment' : 'teammember'}`,
        name: `${data.type === "Company" ? '' : data.name}_`,
        model: data.type === "Tag Doc" ? 'Company' : data.type
      }]
      this.nameOptions = [...new Map(this.nameOptions.map(item => [item['id'], item])).values()]
      this.showDivision = data.type === 'Company' ? true : false
      this.showPublic = data.type !== "Driver" ? true : false
      this.modelType = data.type === "Tag Doc" ? 'Company' : data.type
      this.isTagDoc = data.type === "Tag Doc"
      this.editDocumentFlag = true;
      this.documentIndex = id;
      this.documentData = { ...this.allCompanyDocs[id], doc_type: this.allCompanyDocs[id].doc_type_info.id, date: moment.tz(this.allCompanyDocs[id].date, this.userTimeZone).toDate(), expiry_date: this.allCompanyDocs[id].expiry_date ? moment.tz(this.allCompanyDocs[id].expiry_date, this.userTimeZone).toDate() : "" };
      this.documentData.name = `${data.type}-${data.type === "Company" ? this.userCompany : data.userID}`;
      this.documentData.docName = name
      this.documentData.type = data.type
      this.documentData.tags = data.tags.length ? data.tags.map((tag) => tag.id) : []
      this.documentData.tagged_model = data.tagged_model;
      if (this.documentData.document) {
        let file_name = "";
        if (typeof this.documentData.document === "string") {
          file_name = this.documentData.document;
        } else {
          file_name = this.documentData.document.name;
        }
        this.fileName = file_name.split("/").pop().split("#")[0].split("?")[0];
      } else {
        this.documentData.document = null;
        this.fileName = "";
      }
      this.errors = {
        date: null,
        name: null,
        document: null,
        description: null,
        ...this.company[0].doc_type ? { doc_type: null } : {}
      };
      this.defaultData = JSON.parse(JSON.stringify({ ...this.documentData, doc_type: this.allCompanyDocs[id].doc_type_info.id ? this.allCompanyDocs[id].doc_type_info.id : '' }))
      this.$bvModal.show("modal-document");
    },
    async updateDocumentOnToggle(data, key, value) {
      try {
        this.setLoader(true)
        data[key] = value;
        delete data.document;
        delete data.tags
        await this.updateTeamMemberDocument({
          id: data.pk,
          payload: { ...data, date: moment(data.date).format("YYYY-MM-DD"), expiry_date: data.expiry ? moment(data.expiry).format("YYYY-MM-DD") : null },
        });
        await this.setNotification({
          msg: this.$t('fileDropPage.docUpdatedShort'),
          type: "success",
          color: "green",
        });
        await this.getAllDocs();
        this.setLoader(false)
      } catch (error) {
        this.setLoader(false)
        await this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async setFileDrop(type) {
      this.fileDrop = type
      this.currentPage = 1
      this.resetFilterFields()
    },
    async getAllDocs() {
      try {
        this.isBusy = true
        let url = ""
        let tags = ""
        if (window.location.search) {
          url = window.location.search?.split("?")[1]
        }
        else {
          Object.keys(this.filterFields).map((key) => {
            if (this.filterFields[key] !== '') {
              if (key === "tags" && this.filterFields[key].length > 0) {
                this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                url += `${key}=${encodeURIComponent(tags)}&`
              }
              if (key !== 'search_field' && key !== "tags") url += `${key}=${this.filterFields[key]}&`
              else {
                let searchList = ""
                this.fields.filter((item) => item.visible && item.field === 'text').map(({ key }, index) => index === 0 ? searchList = key : searchList += ',' + key)
                url += `${key}=${this.filterFields[key]}&search_list=${searchList}&`
              }
            }
          })
          localStorage.setItem(
            "docs_filters",
            JSON.stringify({
              filterFields: this.filterFields
            })
          );
          if (this.sortBy) {
            url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
          }
          else {
            url += `sort_field=date&sort_order=desc&`
          }

          url += `page=${this.currentPage}&page_size=${this.perPage}&file_drop=True`
        }
        const data = await this.getCompanyDocs({ url, company_id: this.userCompany });
        if (data.file_drop_docs_count) {
          this.rows = data.file_drop_docs_count
          {
            const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
            const end = this.perPage * (this.currentPage - 1) + data.queryset_count
            this.positionText = this.$t('fileDropPage.positionText', { start, end, total: data.file_drop_docs_count })
          }
        }
        else {
          this.rows = 0
          this.positionText = this.$t('fileDropPage.emptyPosition')
        }
        this.updateDocs();
        if (this.$route.query.document_id) {
          const documentIndex = this.items.findIndex(item => item.pk === parseInt(this.$route.query.document_id))
          if (documentIndex !== -1) {
            this.openDoc(this.items[documentIndex])
          }
        }
        this.isBusy = false
        this.isTableMounted = true
      }
      catch (e) {
        this.isBusy = false
        this.isTableMounted = true
        console.log(e)
      }
    },
    async updateDocs() {
      this.items = [];
      this.allCompanyDocs.forEach((doc, id) => {
        if (
          !doc.document_of.role ||
          (doc.document_of.role &&
            (doc.document_of.role === "Driver" ||
              doc.document_of.role === "Company"))
        ) {
          let color;
          let expiryColor;
          let daysDiff = "-";
          if (doc.expiry_date) {
            const currentDate = new Date();
            const expiryDate = new Date(doc.expiry_date);
            const diffDays = parseInt(
              (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
              10
            );
            if (diffDays > 30) {
              color = "color:black";
            } else if (diffDays <= 30 && diffDays >= 1) {
              color = "color:#FFC800";
            } else color = "color:#FF0000";
            daysDiff = parseInt(
              (new Date(doc.expiry_date) - new Date()) / (1000 * 60 * 60 * 24),
              10
            );
            if (daysDiff <= 0) {
              expiryColor = "color:red";
            } else if (daysDiff <= 31 && daysDiff >= 1) {
              expiryColor = "color:#FFC800";
            } else {
              expiryColor = "color:green";
            }
          }
          this.items.push({
            name: doc.name,
            type: doc.document_type,
            description: doc.description,
            data_extraction_requested: doc.data_extraction_requested,
            date: moment(doc.date).format("ll"),
            document_status: doc.document_status,
            expiry: doc.expiry_date,
            expiry_date: doc.expiry_date
              ? `<span style=${color}>${moment(doc.expiry_date).format(
                "ll"
              )}</span>`
              : "-",
            id: id,
            pk: doc.id,
            link: doc.document,
            color: expiryColor,
            expiry_days: daysDiff,
            userID: doc.document_of.id,
            doc_type: doc.doc_type_info.id,
            doc_type_name: doc.doc_type_info.type ? doc.doc_type_info.type : '-',
            file_drop: doc.file_drop,
            source: (doc.uploaded_by_driver || doc.data_extraction_requested) ? doc.uploaded_by_driver ? 'Driver' : 'BOT' : '-',
            object_id: doc.object_id,
            rejected: doc.rejected,
            rejection_reason: doc.rejection_reason,
            documentName: doc.document_name,
            tags: doc.tags_obj,
            tagged_model: doc.tagged_model,
          });

        }
      });
      if (this.items.length === 0) this.emptyTable = true
      else this.emptyTable = false
    },
  },
  watch: {
    userPreferences: {
      async handler() {
        if (this.userPreferences) {
          this.fields = this.userPreferences['File Drop'].sort((a, b) => a.display_order - b.display_order).map((col) => {
            return { ...col, thClass: 'font-table-weight-bold', ...col.key === 'selected' ? { thStyle: { minWidth: "20px", width: "20px" } } : {} }
          })
        }
      },
      immediate: true
    },
    perPage: {
      async handler() {
        await this.getAllDocs();
      },
      immediate: true,
    },
    currentPage: {
      async handler() {
        await this.getAllDocs();
      },
    },
    sortBy: {
      async handler() {
        await this.getAllDocs();
      },
    },
    sortDesc: {
      async handler() {
        await this.getAllDocs();
      },
    },
    filterFields: {
      handler() {
        this.currentPage = 1
      },
      deep: true
    },
    company: {
      async handler() {
        await this.getAllTags(this.userCompany);
        this.tags.map((item) => {
          this.allTags.push({
            id: item.add_tag,
            label: item.add_tag,
          });
          this.docTags.push({
            id: item.id,
            label: item.add_tag,
          });
        });
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    this.getDocumentUploadStatus()
  },
  beforeDestroy() {
    this.revokeInlineMedia()
  }
};
</script>
<style>
.documents-alert-section {
  background-color: white;
  color: black;
  padding: 11px 18px;
  border-radius: 5px;
  margin-bottom: 26px;
  font-weight: 500;
  border-left: 10px solid #FF0000;
}

.documents-progess-section {
  background-color: white;
  border-left: 10px solid #FFC800;
  color: black;
  padding: 11px 18px;
  border-radius: 5px;
  margin-bottom: 26px;
  font-weight: 500;
}

.error-button {
  z-index: 1;
}</style>
